export default "__VITE_ASSET__KUX9CIFN__"